import { useMemo } from 'react';
import dayjs from 'dayjs';

import { useModal } from '@/features/Modals';
import { formatWithCommas, formatWithMaxPrecision } from '@/shared/utils/helpers';

const SECONDS_PER_YEAR = 365 * 24 * 60 * 60;

export const useGetTotalAssets = () => {
    const { modalProps } = useModal();

    const { totalAssets, totalBorrowed, assetsFetched, currentApy, decimals } = modalProps || {};

    const asset = useMemo(() => {
        if (!assetsFetched || !totalAssets || !totalBorrowed || !currentApy) return totalAssets;

        const elapsedSeconds = dayjs().diff(dayjs(assetsFetched), 'second');
        const timeFractionOfYear = elapsedSeconds / SECONDS_PER_YEAR;

        const accruedInterest = Number(totalBorrowed) * currentApy * timeFractionOfYear;

        const result = Number(totalAssets) + accruedInterest;

        return result.toFixed(decimals);
    }, [totalAssets, totalBorrowed, assetsFetched, currentApy]);

    const formatedAsset = useMemo(() => {
        return formatWithCommas(formatWithMaxPrecision(asset, decimals));
    }, [asset]);

    return {
        asset,
        formatedAsset,
    };
};
